'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdChildCare = function MdChildCare(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm12.5 23.4h15c-1.2 2.9-4.1 5-7.5 5s-6.2-2.1-7.5-5z m7.5 8.2c5.3 0 9.8-3.5 11.2-8.3 0.1 0 0.3 0.1 0.4 0.1 1.8 0 3.4-1.6 3.4-3.4s-1.6-3.4-3.4-3.4c-0.1 0-0.3 0.1-0.4 0.1-1.4-4.8-5.9-8.3-11.2-8.3s-9.8 3.5-11.2 8.3c-0.1 0-0.3-0.1-0.4-0.1-1.8 0-3.4 1.6-3.4 3.4s1.6 3.4 3.4 3.4c0.1 0 0.3-0.1 0.4-0.1 1.4 4.8 5.9 8.3 11.2 8.3z m18.2-10.5c-0.4 2.5-2.2 4.6-4.6 5.3-2.2 4.6-7.4 8.6-13.6 8.6-6.2 0-11.4-3.9-13.5-8.6-2.4-0.7-4.3-2.8-4.7-5.3-0.1-0.3-0.2-0.7-0.2-1.1s0.1-0.8 0.2-1.1c0.4-2.5 2.3-4.6 4.7-5.3 0.8-1.9 2-3.5 3.6-4.8 2.6-2.4 6.1-3.8 9.9-3.8 6.3 0 11.3 3.8 13.5 8.6 2.4 0.7 4.3 2.8 4.7 5.3 0.1 0.3 0.2 0.7 0.2 1.1s-0.1 0.8-0.2 1.1z m-24.4-3.6c0-1.2 0.9-2.1 2.1-2.1s2 0.9 2 2.1-0.9 2.1-2 2.1-2.1-0.9-2.1-2.1z m8.3 0c0-1.2 0.9-2.1 2-2.1s2.2 0.9 2.2 2.1-1 2.1-2.2 2.1-2-0.9-2-2.1z' })
        )
    );
};

exports.default = MdChildCare;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/child-care.js
// module id = 2929
// module chunks = 0